<spinner [id]="'approvecomp'" [show]='activeSpinner'></spinner>
<div class="tab-content">
  <div role="tabpanel" class="tab-pane fade active show" id="pending">
    <div class="row">
      <div class="col-12 col-xl col-md-6 mb-2 mb-xl-0">
        <div>
          <label>{{'header.assesmentyear' | translate }}<span class="required-field">*</span></label>
          <select [(ngModel)]="triggercomputedlist['ay']" class="form-control custom-selectbox">
            <option *ngFor="let year of assesmentlist" value="{{year}}">{{year}}</option>
          </select>
        </div>
      </div>

      <div class="col-12 col-xl col-md-6 mb-2 mb-xl-0">
        <div>
          <label>{{'dataSubs.month' | translate }}<span class="required-field">*</span></label>
          <select [(ngModel)]="triggercomputedlist['montharray']" class="form-control custom-selectbox">
            <option value="" [disabled]="true">{{'monthmaps.selcecttag' | translate}}</option>
            <option *ngFor="let month of monthsList" [value]="month.key">
              {{'monthmaps.' + month['value'] | translate}}</option>
          </select>
        </div>
      </div>

      <div class="col-12 col-xl col-md-6 mb-2 mb-xl-0" *ngIf="showdistdrop">
        <div>
          <label>{{'header.district' | translate }}<span class="required-field">*</span></label>
          <select [(ngModel)]="selectedistrict" (change)="getdistuuid(selectedistrict)"
            class="form-control custom-selectbox">
            <option value="undefined">{{'tabledataforstates.all' | translate}}</option>
            <option *ngFor="let district of DistrictList" value="{{district['uuid']}}">
              {{ 'districtsdata.' + district['name'] | translate}}</option>
          </select>
        </div>

      </div>

      <div class="col-12 col-xl d-flex align-items-end justify-content-start">
        <div>
          <button class="btn btn-info btn-sm mr-2" (click)="getTabledata()" name="submit"
            type="button">{{'dataSubs.VIEW' | translate }}</button>
        </div>
      </div>

      <div class="col-auto d-flex justify-content-end align-items-end w-100 mt-2 mt-xl-2">
        <div class="btn-group">
          <!-- <button class="btn btn-info btn-sm mr-2" (click)="approveclick()" name="approval" type="button">Approve</button> -->
          <button class="btn btn-info btn-sm mr-2" (click)="approveOrrejectclick('approve')" name="submit"
            type="button">{{'header.submit' | translate }}</button>
        </div>
      </div>
    </div>
  </div>
</div>




<table class="table text-center table-sm mt-1">
  <thead class="thead-light">
    <tr>
      <th class="positiontest">
        <div class="custom-control custom-checkbox">
          <input type="checkbox" (change)="checkallset(checkall)" name="selectall" [(ngModel)]="checkall"
            class="custom-control-input" id="selectall">
          <label class="custom-control-label" for="selectall"></label>
        </div>
        <input type="checkbox" name="selectall" class="custom-control-input" id="selectall">
      </th>
      <th scope="col" class="positiontest">{{'submitdata.slno' | translate}}</th>
      <th>{{'dataSubs.distname' | translate}}</th>
      <th>{{ 'trigManage.mandatoryindicatorscount' | translate}}</th>
      <th>{{ 'trigManage.DGCMapprovedcount' | translate}}</th>
      <th>{{ 'trigManage.DGCVMapprovedcount' | translate}}</th>
    </tr>
  </thead>
  <tbody class="text-white">
    <ng-container *ngFor="let table of tabledata | keyvalue;let i=index">
      <tr>
        <td>
          <div class="custom-control custom-checkbox">
            <input [disabled]="table['checkboxdisb']" type="checkbox" class="custom-control-input"
              [(ngModel)]="table['value']['ischecked']" id="{{i+1}}">
            <label class="custom-control-label" for="{{i+1}}"></label>
          </div>
        </td>
        <td scope="row">{{i+1}}</td>
        <td scope="row">{{table['value']['name']}}</td>
        <td scope="row">{{table['value']['mandatoryCount']}}</td>
        <td scope="row">{{table['value']['STATE_NODAL_OFFICER']}}</td>
        <td scope="row">{{table['value']['VALIDATION_AGENCY']}}</td>
      </tr>
    </ng-container>
  </tbody>
</table>